var _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_333_40)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 65,
    r: 65,
    fill: "#F4BE59"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dii_333_40)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 65,
    r: 53,
    fill: "#02A6E6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.0787 70.2783C88.195 69.1932 87.0252 67.1716 87.0252 65.0001C87.0252 62.8297 88.1949 60.808 90.0732 59.7239C92.0009 58.6157 92.8027 56.313 91.9789 54.2491C90.9464 51.642 89.5405 49.207 87.8105 47.0106C86.4321 45.262 84.0376 44.804 82.11 45.9194C80.2318 47.0106 77.8921 47.0139 76.0085 45.9276C74.1302 44.8413 72.9659 42.8164 72.9714 40.641C72.9714 38.4156 71.3787 36.5688 69.1766 36.2502C66.4046 35.8491 63.589 35.8518 60.8178 36.2584C58.621 36.5792 57.0284 38.425 57.0338 40.6459C57.0338 42.8186 55.8695 44.8423 53.9913 45.9276C52.1075 47.0127 49.7735 47.0105 47.8898 45.9204C45.9622 44.805 43.5677 45.2652 42.1892 47.0139C41.326 48.1113 40.5423 49.269 39.8442 50.4782C39.1467 51.6859 38.5371 52.9518 38.0209 54.2385C37.1915 56.3057 37.9934 58.6117 39.9211 59.7228C41.8049 60.8069 42.9746 62.8295 42.9746 65C42.9746 67.1704 41.8049 69.1914 39.9266 70.2771C37.999 71.3855 37.1972 73.6871 38.0209 75.7504C39.0516 78.3529 40.4558 80.7914 42.1892 82.9893C43.5677 84.738 45.9622 85.1959 47.8898 84.0805C49.7681 82.9893 52.1076 82.9871 53.9913 84.0723C55.8695 85.1587 57.0338 87.1836 57.0338 89.3589C57.0283 91.5837 58.6264 93.4306 60.8232 93.7498C62.1964 93.9486 63.5821 94.0484 64.9695 94.0485C66.3755 94.0485 67.7814 93.9463 69.1818 93.7415C71.3786 93.4202 72.9712 91.576 72.9712 89.355C72.9657 87.1813 74.13 85.1575 76.0082 84.0723C77.8919 82.9872 80.2261 82.9894 82.1097 84.0795C84.0373 85.1949 86.4318 84.7357 87.8103 82.986C88.673 81.8886 89.4567 80.7313 90.1553 79.5228C90.8473 78.3152 91.468 77.0492 91.9787 75.7614C92.8082 73.6942 92.0064 71.3876 90.0787 70.2783ZM72.4716 69.315C71.3238 71.3109 69.462 72.7393 67.2324 73.3357C65.0082 73.9321 62.6796 73.6263 60.686 72.4729C56.5671 70.0938 55.1502 64.8067 57.5281 60.685C59.1208 57.9203 62.0315 56.3727 65.0136 56.3727C66.48 56.3727 67.9573 56.744 69.3138 57.5272C73.4327 59.9057 74.8496 65.1944 72.4716 69.315Z",
    fill: "#FFCC6B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_333_40",
    x: -1,
    y: -2,
    width: 131,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.49 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_333_40"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dii_333_40",
    x: 9.7,
    y: 8,
    width: 112.3,
    height: 111.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_333_40"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_333_40",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_333_40"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_333_40",
    result: "effect3_innerShadow_333_40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.f42831d14b3e66e1b5b0f4979a3b21c6.svg";
export { ForwardRef as ReactComponent };